import React from 'react';
import { useController, Control } from 'react-hook-form';
import BaseInput, { BaseInputProps } from './';

interface ReactHookFormInputProps extends Omit<BaseInputProps, 'onChange' | 'value'> {
  name: string;
  control: Control<any>;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void; // tambahan onChange opsional
}

const ReactHookFormInput: React.FC<ReactHookFormInputProps> = ({
  name,
  control,
  onChange: additionalOnChange,
  ...props
}) => {
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    field.onChange(e);
    if (additionalOnChange) additionalOnChange(e); 
  };

  return (
    <BaseInput
      {...field}
      {...props}
      onChange={handleChange}
      errorMessage={error?.message}
    />
  );
};

export default ReactHookFormInput;
